import get from 'lodash/get';
import { createModuleDescriptor } from '../../redux/module-descriptor';

export default createModuleDescriptor('leads', {
  autocomplete: [
    {
      name: 'pipeline',
      url: '/api/pipelines.json',
      timeToLive: 15 * 60000,
      getId: entry => entry.id,
      getLabel: (entry, locale) =>
        get(
          entry.name.find(n => n.lang === locale),
          'name'
        ) ||
        get(
          entry.name.find(n => n.name),
          'name'
        ),
    },
  ],
});
